import React from 'react';

import { withStyles } from '@mui/styles';
import { Button, Paper } from '@mui/material';

import ComponentWrapper from '../../../common/ComponentWrapper';
import LoaderNew from '../../../common/LoaderNew';
import CommonStyles from '../../../common/CommonStyles';
import PasswordRecoverAndAccountCreate from '../../../common/PasswordRecoverAndAccountCreate';

const styles = {
  paper: {
    padding: '40px',
    width: 'fit-content',
    minWidth: '400px',
    boxShadow: '0px 3px 5px rgba(0, 0, 2, 0.1)',
  },
  dialogBlock: {
    minWidth: '360px',
    width: 'fit-content',
    margin: 'auto',
  },
  dialogTitle: {
    fontSize: 20,
    marginBottom: '16px',
    fontWeight: 'bold',
    color: '#222029',
  },
  closeDialog: {
    cursor: 'pointer',
    lineHeight: '0px',
    opacity: '0.6',
    float: 'right',
    '&:hover': {
      opacity: 1,
    },
  },
  messageBlock: {
    display: 'flex',
    flexDirection: 'column',
    color: '#168CCE',
    padding: 15,
    background: '#E1EBF1',
  },
  messageTitle: {
    fontSize: '15px',
    marginBottom: '8px',
    color: '#222029',
    lineHeight: '20px',
    '& a': {
      textDecoration: 'none',
      color: '#347CFF',
      cursor: 'pointer',
      fontWeight: 'bold',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  backIcon: {
    zIndex: 5,
    fontSize: '20px',
    color: '#878787',
    '&:hover': {
        cursor: 'pointer',
        color: '#4C4C4C',
    },
  },
  okBtn: {
    height: '37px',
    marginTop: '10px',
    width: '100%',
    borderRadius: '20px',
    backgroundColor: '#222029',
    color: 'white',
    opacity: '0.8',
    '&:hover': {
      opacity: '1.0',
      backgroundColor: '#222029',
    },
  },
  insetShadowInput: {
    backgroundColor: '#F5F5F5',
    boxShadow: 'inset 0px 1px 1px #D6D6D6',
    width: '97%',
    fontSize: 14,
    height: '30px',
    padding: '4px',
    border: 'none',
    '&:focus': {
        outline: '1px solid #70b8ff'
    },
  },
  ...CommonStyles,
};

const TYPE_SIGN_IN = 0;
const TYPE_PASS_RECOVERY = 1;
const TYPE_INVITE_REQUEST = 2;

class LogInForm extends ComponentWrapper {
  constructor(props) {
    super(props);
    this.state = { type: TYPE_SIGN_IN, loading: false, password: '', login: '' };
    this.urls = ['/rest/do_sign_in', '/rest/pass_recovery', '/rest/request_invite'];
    this.titles = ['Sign in!', 'Recover password', 'Request invitation'];
  };

  doAuth = () => {
    const { login, password } = this.state;
    const trimmedLogin = login ? login.trim() : '';
    
    if (!this.state.loading) {
      this.setState({ loading: true, login: trimmedLogin }, () => {
        this.postWithData({
          url: this.urls[this.state.type],
          data: {
            login: trimmedLogin,
            password,
          },
          cb: (data) => {
            if (this.state.type === TYPE_SIGN_IN && data._status === 'ok') {
              if (data._rurl) document.location.href = `${data._rurl}`;
            } else {
              this.setState({ loading: false });
              if (data._status === 'ok') this.setState({ type: TYPE_SIGN_IN });
            }
          }
        });
      });
    }
  };

  doEnterPress = (e) => {
    if (e.key === 'Enter') this.doAuth();
  };

  backToMainAuthWindow = () => {
    this.setState({ type: TYPE_SIGN_IN });
  };

  render () {
    const { classes } = this.props;
      
    const buttonOk =
      <Button
        disableElevation
        size="small"
        variant="contained"
        className={classes.okBtn}
        onClick={this.doAuth}>
        {this.state.loading ? <LoaderNew color='white'/> : 'Submit'}
      </Button>;

    const signInComponent =
      <div>
        <div className={`${classes.alignJustifyCenter} ${classes.mb10}`}>
          {/* <h3>Sign in</h3> */}
          <span className={`${classes.dialogTitle}`}>Sign in</span>
        </div>
        <div className={classes.dialogBlock} style={{ fontSize: 12, minWidth: '360px', width: 'fit-content' }}>
          <div style={{paddingBottom: '7px', display: 'block'}}>
            <div className={classes.mb5}>
              <span className={classes.helpText}>
                {'Your email'}
              </span>
            </div >
              <input
                autoFocus
                value={this.state.login}
                placeholder="email@example.com"
                className={`${classes.insetShadowInput} ${classes.mb5}`}
                onChange={(e) => this.setState({ login: e.target.value })}
                onKeyPress={this.doEnterPress}
              />
          </div>

          <div style={{paddingBottom: '7px', display: 'block'}}>
            <div className={classes.mb5}>
              <span className={classes.helpText}>
                {'Password'}
              </span>
            </div>
            <input
              type='password'
              className={`${classes.insetShadowInput}`}
              onChange={(e) => { this.setState({ password: e.target.value }); }}
              onKeyPress={this.doEnterPress}
            />
          </div>

          <div style={{textAlign: 'right'}} className={classes.mb30}>
            {buttonOk}
          </div>

          <div className={`${classes.alignJustifyCenter} ${classes.column}`}>
            <div className={classes.alignCenter} style={{padding: '0px 0px 10px 2px'}}>
              <span className={`${classes.helpText} ${classes.mr5}`}>
                Forgot password?
              </span>
              <a
                onClick={(e) => { this.setState({ type: TYPE_PASS_RECOVERY }); }}
                className={`${classes.helpAction}`}>
                Reset
              </a>
            </div>

            <div className={classes.alignCenter} style={{ padding: '0px 0px 10px 2px' }}>
              <span className={`${classes.helpText} ${classes.mr5}`}>
                Don't have an account yet?
              </span>
              {window.location.host === 'mlkwb.ai' ? // || window.location.host === 'localhost:8080'
                <a
                  className={`${classes.helpAction}`} rel="noreferrer" href={`/signup`}>
                  Sign up
                </a>
                :
                <a
                  onClick={(e) => this.setState({ type: TYPE_INVITE_REQUEST })}
                  className={`${classes.helpAction}`}>
                  Sign up
                </a>
              }
            </div>
          </div>
      </div>
    </div>;

    const actionComponent =
      <div style={{fontSize: '12', width: '100%', verticalAlign: 'middle'}}>
        <PasswordRecoverAndAccountCreate
          classes={classes}
          newSetupCreation={this.state.type === TYPE_INVITE_REQUEST}
          backToMainAuthWindow={this.backToMainAuthWindow}
        />
      </div>;

    return (
      <Paper className={classes.paper} style={{...this.props.style}}>
        <div className={`${classes.dialogTitle}`}>
          <div className={`${classes.justifyCenter} ${classes.mb40}`}>
            {window.location.hostname === 'mlkwb.ai' ?
                <img src="/images/Milkyweb_green_S_site.svg" alt="MilkywebAi logo" />
                :
                <img src="/images/Milkyweb_blue_S_site.svg" alt="Milkyweb logo" />
            }
          </div>
        </div>
        {this.state.type === TYPE_SIGN_IN && signInComponent}
        {this.state.type === TYPE_PASS_RECOVERY && actionComponent}
        {this.state.type === TYPE_INVITE_REQUEST && actionComponent}
      </Paper>
    );
  }
};

export default withStyles(styles)(LogInForm);
